import { render } from "./cart-freebies.vue?vue&type=template&id=b7c57ad8"
import script from "./cart-freebies.vue?vue&type=script&lang=js"
export * from "./cart-freebies.vue?vue&type=script&lang=js"

import "./cart-freebies.vue?vue&type=style&index=0&id=b7c57ad8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__